import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { selectCurrentUserData } from '../../+state/user-identity/user-identity-settings.selectors';
import { UserIdentityService } from '../services/userIdentity/user-identity.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const userIdentityService = inject(UserIdentityService);

  try {
    // Wait for Firebase auth initialization
    await userIdentityService.initializeAuthState();

    return new Promise((resolve) => {
      store
        .select(selectCurrentUserData)
        .pipe(take(1))
        .subscribe((userData) => {
          if (userData) {
            resolve(true);
          } else {
            router.navigate(['/welcome'], {
              queryParams: { redirectUrl: state.url },
            });
            resolve(false);
          }
        });
    });
  } catch (_error) {
    router.navigate(['/welcome'], { queryParams: { redirectUrl: state.url } });
    return false;
  }
};
